import React from 'react';
import ImageTitleDescription from 'components/ImageTitleDescription';
import Welcome from 'modules/Onboarding/components/Welcome';
import ExperianMonitorData from 'assets/svgs/experian-monitor-data.svg';
import FundingInstantOffers from 'assets/svgs/funding-instant-offers.svg';
import CreditProfileStar from 'assets/svgs/credit-profile.svg';
import { IconArrowForward } from '@capitalise/ui-design-system';
import DirectorConsentOnboarding from '../containers/DirectorConsentOnboarding';
import PlanStep from '../components/PlanStep';
import { Analytics } from 'utils/Analytics';
import { AnalyticsEventAction, AnalyticsEventCategory } from 'enums/analytics-types';
import { PaymentOrigin } from '@capitalise/common';

export default ({
  completeOnboarding,
  goToRoute,
  redirectToPaymentFlow,
  shouldDisplayDirectorConsent,
  shouldDisplayPlans,
  user,
}) => [
  {
    label: 'Welcome',
    lead: 'We’re excited to have you onboard, because together we can build a better future for SMEs!',
    title: 'Welcome to Capitalise!',
    component: Welcome,
    iconButton: null,
    nextButtonLabel: 'Continue to onboarding',
  },
  {
    key: 'credit-profile',
    lead: `See what is influencing your business credit score, powered by Experian. Check the health of your business and any risks with our credit profile.`,
    label: 'Credit profile',
    title: 'View your credit profile',
    component: ImageTitleDescription,
    hasPrevious: true,
    image: CreditProfileStar,
    iconButton: IconArrowForward,
  },
  {
    lead: 'Capitalise makes it easy to find, compare and select lenders who match your business profile. <br>Our lenders offer an extensive range of finance products - so you will find an option that works best for your business.',
    label: 'Find funding',
    title: 'Find funding for your business',
    component: ImageTitleDescription,
    hasPrevious: true,
    image: FundingInstantOffers,
    iconButton: IconArrowForward,
    nextButtonLabel:
      !shouldDisplayDirectorConsent && !shouldDisplayPlans ? 'Go to Today page' : 'Continue',
    nextButtonAction:
      !shouldDisplayDirectorConsent && !shouldDisplayPlans
        ? () => {
            completeOnboarding();
            Analytics.track(AnalyticsEventCategory.onboard, AnalyticsEventAction.completed, {
              extraParams: { key: 'compare-plans' },
            });
            goToRoute('/business/today');
          }
        : null,
    isLastStep: !shouldDisplayDirectorConsent && !shouldDisplayPlans,
  },
  ...(shouldDisplayPlans
    ? [
        {
          lead: 'Protect your cash flow and reduce risk to your business by knowing and monitoring the financial stability of your customers or partners.',
          label: 'Monitor risks',
          title: `Monitor other companies risks`,
          component: ImageTitleDescription,
          hasPrevious: true,
          image: ExperianMonitorData,
          iconButton: IconArrowForward,
        },
        {
          key: 'compare-plans',
          lead: 'By upgrading your plan, you will gain access to your full Experian credit profile and the ability to credit check other companies.',
          nextButtonLabel: !shouldDisplayDirectorConsent ? 'Go to Today page' : 'Continue',
          nextButtonAction: !shouldDisplayDirectorConsent
            ? () => {
                completeOnboarding();
                Analytics.track(AnalyticsEventCategory.onboard, AnalyticsEventAction.completed, {
                  extraParams: { key: 'compare-plans' },
                });
                goToRoute('/business/today');
              }
            : null,
          isLastStep: !shouldDisplayDirectorConsent,
          label: 'Plans',
          title: 'Upgrade your plan for your Full Experian Credit Profile',
          component: PlanStep,
          hasPrevious: true,
          iconButton: IconArrowForward,
          options: { user },
          skipButtonLabel: 'Compare plans',
          skipCallback: () => {
            completeOnboarding();
            redirectToPaymentFlow(PaymentOrigin.CREDIT_PROFILE);
          },
        },
      ]
    : [
        {
          lead: 'Protect your cash flow and reduce risk to your business by knowing and monitoring the financial stability of your customers or partners.',
          label: 'Monitor risks',
          title: `Monitor other companies risks`,
          nextButtonLabel: !shouldDisplayDirectorConsent ? 'Go to Today page' : 'Continue',
          component: ImageTitleDescription,
          isLastStep: !shouldDisplayDirectorConsent,
          hasPrevious: true,
          image: ExperianMonitorData,
          iconButton: IconArrowForward,
          nextButtonAction: !shouldDisplayDirectorConsent
            ? () => {
                completeOnboarding();
                Analytics.track(AnalyticsEventCategory.onboard, AnalyticsEventAction.completed, {
                  extraParams: { key: 'monitor-risks' },
                });
                goToRoute('/business/today');
              }
            : null,
        },
      ]),
  ...(shouldDisplayDirectorConsent
    ? [
        {
          lead: 'Capitalise makes it easy to find, compare and select lenders who match your business profile. <br>Our lenders offer an extensive range of finance products - so you will find an option that works best for your business.',
          nextButtonLabel: 'Continue',
          label: 'Director consent',
          fullComponent: {
            component: DirectorConsentOnboarding,
            componentProps: {
              completeOnboarding: completeOnboarding,
            },
          },
          hasPrevious: true,
        },
      ]
    : []),
];
